import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#DA343F",
  fillRule: "evenodd",
  d: "M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#280104",
  fillRule: "evenodd",
  d: "M6.026 7.897a.5.5 0 0 1 .632-.316l2.333.778a.5.5 0 0 1-.316.949L6.342 8.53a.5.5 0 0 1-.316-.633Zm7.948 0a.5.5 0 0 1-.316.633l-2.333.778a.5.5 0 1 1-.316-.949l2.333-.778a.5.5 0 0 1 .632.316Zm-6.659 4.859a.6.6 0 0 1-.855-.843l.429.42-.429-.42h.001v-.001l.003-.002.005-.006.017-.015.052-.05a4.961 4.961 0 0 1 .88-.615A5.349 5.349 0 0 1 10 10.567c1.106 0 1.982.328 2.582.657.3.164.532.33.693.457a3.698 3.698 0 0 1 .24.208l.016.015.005.006.002.002c.001 0 .002.001-.427.421l.429-.42a.6.6 0 0 1-.855.843l-.004-.004a1.653 1.653 0 0 0-.152-.13 3.742 3.742 0 0 0-.524-.346 4.148 4.148 0 0 0-2.005-.51c-.862 0-1.541.256-2.005.51a3.746 3.746 0 0 0-.65.451l-.026.025-.004.004Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#121212",
  fillRule: "evenodd",
  d: "M8.639 9.222a.778.778 0 1 1-1.556 0 .778.778 0 0 1 1.556 0Zm4.278 0a.778.778 0 1 1-1.556 0 .778.778 0 0 1 1.556 0Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#280104",
  d: "m6.966 12.398-.006.006a.1.1 0 0 1-.141 0l.42-.428-.032-.031A4.849 4.849 0 0 1 10 11.067a4.85 4.85 0 0 1 2.793.878l-.032.031.42.429a.1.1 0 0 1-.14-.001l-.007-.006-.004-.004-.002-.002a2.988 2.988 0 0 0-.189-.163 4.255 4.255 0 0 0-.594-.391A4.648 4.648 0 0 0 10 11.267a4.65 4.65 0 0 0-2.245.57 4.253 4.253 0 0 0-.746.52c-.017.016-.03.027-.037.035l-.002.002-.004.004Zm-.148-.134v-.001l.001-.002.002-.001.007-.007a.162.162 0 0 1-.01.01Zm.026-.674A5.349 5.349 0 0 1 10 10.567a5.349 5.349 0 0 1 3.155 1.022h-6.31Z"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=WorstPainPossibleIcon20.js.map